<h1 mat-dialog-title>{{isEdit ? 'Edit Co-branding' : 'Add Co-branding'}}</h1>

<div mat-dialog-content>
  <form [formGroup]="form" class="form">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>
      <mat-form-field appearance="outline" class="url-field">
        <mat-label>URL</mat-label>
        <input matInput formControlName="url">
        <span matSuffix>.wallit.app</span>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="fullwidth">
      <mat-label>Tagline</mat-label>
      <input matInput formControlName="tagline">
    </mat-form-field>

    <div class="row">
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Primary Color</mat-label>
          <input matInput formControlName="primary" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('primary')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Secondary Color</mat-label>
          <input matInput formControlName="secondary" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('secondary')?.value"></span>
      </div>
    </div>

    <div class="row">
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Tertiary Color</mat-label>
          <input matInput formControlName="wallitTertiaryColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitTertiaryColor')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Gradient SW Color</mat-label>
          <input matInput formControlName="wallitGradientSWColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitGradientSWColor')?.value"></span>
      </div>
      <div class="color-field">
        <mat-form-field appearance="outline">
          <mat-label>Wallit Gradient NE Color</mat-label>
          <input matInput formControlName="wallitGradientNEColor" (input)="changeColor($event)">
        </mat-form-field>
        <span class="color" [style.backgroundColor]="form.get('wallitGradientNEColor')?.value"></span>
      </div>
    </div>

    <div class="file-field">
      <label class="file-label">Logo on Light</label>
      <input type="file" (change)="onFileChange($event, 'logo')">
      @if (logoPreview) {
        <img [src]="logoPreview" alt="logo preview" class="preview">
      }
    </div>

    <div class="file-field">
      <label class="file-label">Logo on Dark</label>
      <input type="file" (change)="onFileChange($event, 'light')">
      @if (lightLogoPreview) {
        <img [src]="lightLogoPreview" alt="light logo preview" class="preview">
      }
    </div>

    <div class="file-field">
      <label class="file-label">Horizontal Logo on Light</label>
      <input type="file" (change)="onFileChange($event, 'horizontalLight')">
      @if (horizontalLightLogoPreview) {
        <img [src]="horizontalLightLogoPreview" alt="horizontal light logo preview" class="preview">
      }
    </div>

    <div class="file-field">
      <label class="file-label">Horizontal Logo on Dark</label>
      <input type="file" (change)="onFileChange($event, 'horizontal')">
      @if (horizontalLogoPreview) {
        <img [src]="horizontalLogoPreview" alt="horizontal logo preview" class="preview">
      }
    </div>

    <mat-slide-toggle formControlName="signupDisabled">Signup Disabled</mat-slide-toggle>

    <mat-form-field appearance="outline" class="fullwidth">
      <mat-label>Invitation Branch Link</mat-label>
      <input matInput formControlName="inviteEmailDownloadUrl">
      <mat-hint>The Download Wallit button and QR code use this brand's Branch link.</mat-hint>
    </mat-form-field>
    <p>When a Branch link is supplied, a matching QR code is generated when you save. Branch routes members to iOS, Android, or desktop.</p>
    @if (inviteQrPreview && form.get('inviteEmailDownloadUrl')?.value === savedInviteDownloadUrl) {
      <img [src]="inviteQrPreview" alt="Saved invitation QR code" class="preview">
    }

    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Config JSON</mat-label>
      <app-json formControlName="configjson" baseTable="partners" fieldHint="configjson"></app-json>
    </mat-form-field>

    @if (rewardsInBands.length) {
      <div class="bands">
        <h3>Rewards & Products in Bands</h3>
        @for (reward of rewardsInBands; track reward) {
          <div class="band-row">
            <div class="band-title">{{reward.title}}</div>
            <div class="band-value">{{reward.reward}}</div>
          </div>
        }
      </div>
    }

    @if (invalidField) {
      <div class="error">{{invalidField}}</div>
    }
  </form>
</div>

<div class="buttons" mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
  <button mat-button (click)="cancel()">Cancel</button>
</div>
